<template>
    <div class="box-wrap" :style="boxWrapStyleObj">
        <span class="border-left-top"></span>
        <span class="border-left-bottom"></span>
        <span class="border-right-top"></span>
        <span class="border-right-bottom"></span>
        <div class="statis-title bg3"
             ref="statisTitle">
            <span>作业布置与学生作答分析</span>
        </div>
        <div class="content" :style="contentStyleObj">
            <div class="homework-wrap">
                <div class="left-container" style="width: 43%;">
                    <div class="left-title-wrap">
                        <img src="../../../assets/images/databoard/hw-txt-icon.png">
                        <span class="left-title">
        学科作业维度
      </span>
                    </div>
                    <div style="width:100%;height:100%;" id="data_homework"></div>
                </div>
                <div class="right-container" style="width: 57%;">
                    <div class="right-content">
                        <div class="homework-box-wrap">
                            <div class="subject-count-title" :style="rowStyleObj">
                                <span class="subject-title" style="width: 30%">学科</span>
                                <span class="count-title" style="width: 70%">布置/提交</span>
                            </div>
                            <template v-for="(item,index) in stuHomework" v-if="stuHomework.length>0">
                                <div class="subject-count-name" v-if="index%2===0" :style="rowStyleObj"
                                     style="background-color: #102243;">
                                    <span class="subject-name" style="width: 30%">{{item.bank_name}}</span>
                                    <span class="submit-count" style="width: 70%" :title="item.allCount+'份 / '+ item.submitCount+'份'">{{item.allCount}}份 / {{item.submitCount}}份</span>
                                </div>
                                <div class="subject-count-name" v-else :style="rowStyleObj">
                                    <span class="subject-name" style="width: 30%">{{item.bank_name}}</span>
                                    <span class="submit-count" style="width: 70%" :title="item.allCount+'份 / '+ item.submitCount+'份'">{{item.allCount}}份 / {{item.submitCount}}份</span>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "homeworkStatis",
        props: {
            stuHomework: Array,
            // stuHomework: {
            //     type: Array,
            //     default: function () {
            //         return []
            //     }
            // },
            screenHeight: Number,
            titleHeight: Number
        },
        data () {
            return {
                screenWidth: 0,//屏幕宽度
                boxWrapStyleObj: {
                    height: ''
                },
                contentStyleObj: {
                    height: ''
                },
                rowStyleObj: {
                    height: '',
                    lineHeight: ''
                }
            }
        },
        watch: {
            'screenHeight': 'initBoxHeight',
            'titleHeight': 'initBoxHeight',
            'stuHomework': 'initHomework'
        },
        methods: {
            /**
             * 初始化box高度
             */
            initBoxHeight () {
                let winHeight = window.innerHeight;
                if (winHeight < 900) {
                    winHeight = 938;
                }

                let boxWrapHeight = (winHeight - 128 - 10 - 30) / 3;
                let contentHeight = boxWrapHeight - this.$refs.statisTitle.offsetHeight - 20;
                this.boxWrapStyleObj.height = boxWrapHeight + 'px';
                this.contentStyleObj.height = contentHeight + 'px';
                let rowHight = contentHeight / 6;
                this.rowStyleObj.height = rowHight + 'px';
                this.rowStyleObj.lineHeight = rowHight + 'px';
            },
            /**
             * 加载饼状图
             */
            initHomework () {
                let dataSourcePie = this.$echarts.init(document.getElementById('data_homework'));
                let indicatorList = [];
                let dataArr = [];
                // let submitDataArr = [];
                for (let i = 0; i < this.stuHomework.length; i++) {
                    let homeworkObj = {};
                    homeworkObj.text = this.stuHomework[i].bank_name;
                    homeworkObj.max = this.stuHomework[0].allCount;
                    indicatorList.push(homeworkObj);
                    dataArr.push(this.stuHomework[i].allCount);
                    // submitDataArr.push(this.stuHomework[i].submitCount);
                }

                let radiusVal = 45;
                let fontSize = 12;
                let tooltipFontSize = 14;
                if (this.screenWidth <= 1280) {
                    radiusVal = 30;
                }
                // if (this.screenWidth <= 1680) {
                //     radiusVal = 25;
                //     fontSize = 9;
                //     tooltipFontSize= 12;
                // }
                // if (this.screenWidth <= 1028) {
                //     tooltipFontSize= 10;
                // }
                const option = {
                    tooltip: {
                        trigger: 'axis'
                    },
                    radar: [
                        {
                            indicator: indicatorList,
                            center: ['50%', '50%'],
                            radius: radiusVal,
                            shape: 'circle',
                            name: {
                                formatter: '{value}',
                                textStyle: {
                                    color: '#A1B6EB',
                                    fontSize: fontSize
                                }
                            },
                            axisLine: {
                                lineStyle: {
                                    width: 1,
                                    color: '#F9FBFB',
                                    opacity: 0.2
                                }
                            },
                            splitArea: {
                                areaStyle: {
                                    color: ['#2783CD'],
                                    opacity: 0.2,
                                    shadowColor: '#D2F7F9',
                                    shadowBlur: 10
                                }
                            },
                            splitLine: {
                                show: true,
                                lineStyle: {
                                    width: 1,
                                    color: '#0EFCFF',
                                    opacity: 0.45
                                }
                            }
                        }
                    ],
                    series: [
                        {
                            type: 'radar',
                            tooltip: {
                                trigger: 'item',
                                position: ['0%', '0%'],
                                textStyle: {
                                    fontSize: tooltipFontSize
                                }
                            },
                            itemStyle: {
                                normal: {
                                    areaStyle: {
                                        color: {
                                            type: 'linear',
                                            x: 0,
                                            y: 0,
                                            x2: 0,
                                            y2: 1,
                                            colorStops: [{
                                                offset: 0, color: '#0EFCFF'
                                            }, {
                                                offset: 1, color: '#2783CD'
                                            }],
                                            globalCoord: false
                                        },
                                        borderColor: '#000',
                                        opacity: 0.85
                                    },
                                    lineStyle: {
                                        color: '#2675B9'
                                    }
                                }
                            },
                            data: [
                                {
                                    value: dataArr,
                                    name: '学科作业布置维度',
                                    symbol: 'none',
                                    label: {
                                        normal: {
                                            show: false,
                                            fontSize: 10,
                                            formatter: function (params) {
                                                return params.value;
                                            }
                                        }
                                    }
                                }
                            ]
                        }
                    ]
                };
                dataSourcePie.setOption(option);

                window.addEventListener('resize', function () {
                    dataSourcePie.resize();
                });
            }
        },
        mounted () {
            //获取屏幕宽度
            this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../style/databoard";

    .bg3 {
        background-image : url("../../../assets/images/sydataboard/title-bg.png");
    }
</style>
